import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUIList(theme: Theme): Components['MuiList'] {
  return {
    styleOverrides: {
      dense: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
      },
    },
  };
}
